import React from "react";
import { isDigitalSummaryChannelVisible } from "./greatDigitalShared";

const VIEW_OPTIONS = [
  { key: "summary", label: "Summary" },
  { key: "inbound", label: "Inbound" },
  { key: "outbound", label: "Outbound" },
  { key: "email", label: "Emails" },
  { key: "live-chat", label: "Live Chats" },
  { key: "sms", label: "SMS" },
];

export default function GreatChannelNav({ activeKey, onChange, departmentFilter = "", className = "" }) {
  const viewOptions = VIEW_OPTIONS.filter((opt) => isDigitalSummaryChannelVisible(opt.key, departmentFilter));

  return (
    <div className={`w-full sm:w-auto flex flex-col sm:flex-row sm:items-center gap-2 ${className}`}>
      <label className="text-sm font-medium text-navy-700 dark:text-white whitespace-nowrap">View</label>
      <div
        role="group"
        aria-label="GREAT view"
        className="inline-flex w-full flex-wrap justify-center gap-0.5 rounded-md border border-gray-300 bg-gray-100 p-0.5 dark:border-gray-600 dark:bg-navy-800 sm:w-auto"
      >
        {viewOptions.map((opt) => {
          const active = activeKey === opt.key;
          return (
            <button
              key={opt.key}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(opt.key)}
              className={`flex-1 sm:flex-none px-2 py-1 text-xs sm:text-sm font-medium rounded transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                active
                  ? "bg-white text-brand-600 shadow-sm dark:bg-navy-900 dark:text-white"
                  : "bg-transparent text-gray-600 hover:text-navy-700 dark:text-gray-300 dark:hover:text-white"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { VIEW_OPTIONS };
